(function() {
    'use strict';

    angular
        .module('app')
        .factory('AuthenticationService', AuthenticationService);


    AuthenticationService.$inject =
        ['$rootScope', '$timeout', '$cookies', '$localStorage', 'WebApiService', 'SharedData'];

    function AuthenticationService($rootScope, $timeout, $cookies, $localStorage, WebApiService, SharedData) {

        var refreshTimer;
        var connectionTimer;

        var authService = {

            'loginUser': function(userData) {
                userData.grant_type = 'password';
                return WebApiService.postForm('/api/token', userData);
            },


            //This token refresh occurs on view loads, logins, etc.
            'refreshLogin': function (refreshToken) {
                return WebApiService.postForm('/api/token',
                    {
                        grant_type: 'refresh_token',
                        refresh_token: refreshToken
                    });
            },


            //This token refresh occurs automatically at a set time interval
            'autoRefresh': function(refreshToken) {                
                //Perform a network connection test here; recursion occurs in the event of no connection
                authService.checkConnection(refreshToken);
            },


            'setCredentials': function (tokenResponse) {
                var expiresInSeconds = Number(tokenResponse.expires_in);
                var expires = moment().add(expiresInSeconds, 'seconds');
                var sessionExpire = moment().local().add(3, 'hours').format();
                $cookies.put('session', new Date(sessionExpire));

                var currentUser = {
                    isLoggedIn: true,
                    userId: tokenResponse.userId,
                    userName: tokenResponse.userName,
                    firstName: tokenResponse.firstName,
                    lastName: tokenResponse.lastName,
                    accessToken: tokenResponse.access_token,
                    validUntil: expires,
                    refreshToken: tokenResponse.refresh_token,
                    theme: tokenResponse.theme,
                    isFactoryUser: tokenResponse.isFactoryUser === 'True',
                    showStartupHelp: tokenResponse.showStartupHelp === 'True',
                    brandPermissions: JSON.parse(tokenResponse.brands),
                    userPermissions: JSON.parse(tokenResponse.permissions),
                    appVersionId: tokenResponse.appVersionId,
                    defaultBrandId: tokenResponse.defaultBrandId,
                    defaultSeasonId: tokenResponse.defaultSeasonId,
                    defaultDivisionKey: tokenResponse.defaultDivisionKey,
                    useDefaultsInQuickSearch: tokenResponse.useDefaultsInQuickSearch === "True"
                };

                WebApiService.setAuthorization(currentUser.accessToken);

                $localStorage.currentUser = currentUser;

                $rootScope.globals = {
                    currentUser: currentUser 
                };

                if (currentUser.appVersionId !== window.plmVersion.versionId) {
                    $rootScope.versionChange = true;
                }

                var refreshInterval = moment.duration(Number(tokenResponse.refreshInterval), 'minutes').asMilliseconds();
                
                $timeout.cancel(refreshTimer);

                refreshTimer = $timeout(function () {
                        var user = $localStorage.currentUser;
                        if (user && user.refreshToken) {
                            authService.autoRefresh(user.refreshToken);
                        }
                    },
                    refreshInterval);               
            },


            'clearCredentials': function() {                
                $rootScope.globals = {};
                $rootScope.userPermissions = {};
                $rootScope.brandPermissions = {};
                $localStorage.$reset();
                WebApiService.clearAuthorization();
                SharedData.clear();
                $cookies.remove('session');
                $cookies.remove('_cpss');
            },


            'checkConnection': function(refreshToken){
                
                //Ping to determine if connected to server
                $.ajax({
                    url: 'index.html',

                    //Connected to server
                    success: function(result){
                        //Ensure disconnection modal is hidden
                        $rootScope.disconnectModal(false);

                        //Attempt to refresh token
                        WebApiService.postForm('/api/token',
                        {
                            grant_type: 'refresh_token',
                            refresh_token: refreshToken
                        })
                        .then(
                            //Promise resolved -> Token refresh successful
                            function (result) {
                                authService.setCredentials(result);
                            },
                            //Promise rejected -> Token has expired or other error has occurred -> Log user out
                            function () {
                                authService.clearCredentials();
                                $rootScope.logout();
                            }
                        );    
                    },

                    //Disconnected from server     
                    error: function(result){
                        if($rootScope.globals.currentUser){
                            //Display disconnection message to user if logged in
                            $rootScope.disconnectModal(true);

                            $timeout.cancel(connectionTimer);

                            //Reattempt a ping every 2 seconds while disconnected and logged in
                            connectionTimer = $timeout(
                                function () {
                                    return authService.autoRefresh(refreshToken);
                                },
                                2000
                            );      
                        }
                    }
                });                
            }


        };

        return authService;
    }
})();
